export {
  bitcoin,
  solana,
  OmnilockWitnessLock,
  createOmnilockScript,
  setupInputCell,
  CellCollector,
  prepareSigningEntries,
} from "@ckb-lumos/common-scripts/lib/omnilock";
export type { OmnilockInfo } from "@ckb-lumos/common-scripts/lib/omnilock";
